@import '../../shared';

.form-checkbox {
  position: relative;
  margin-bottom: 1.5rem;
  
  &__field {
    display: flex;
    align-items: center;
  }
}

.form-checkbox__hidden {
  position: absolute;
  opacity: 0;
  width: 3.2rem;
  height: 3.2rem;
}

.form-checkbox__styled {
  @include form-component;
  // Use long-hand flex property for IE11. See
  // https://github.com/philipwalton/flexbugs#8-flex-basis-doesnt-support-calc
  flex: 0 0 auto;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: $border-radius-small;
  margin-right: 1.5rem;
  display: inline-block;
}

.form-checkbox__styled--disabled {
  @include form-component-disabled;
}

.form-checkbox__caption {
  padding-top: 0.2rem;
}

.form-checkbox__caption--disabled {
  font-style: italic;
  color: $text-color-secondary;
}

.form-checkbox__checkmark {
  display: none;
  position: absolute;
  top: 0.4rem;
  left: 0.4rem;
  fill: $blue;
}

input[type='checkbox']:checked ~ .form-checkbox__caption {
  font-weight: $font-weight-bold;
}

input[type='checkbox']:focus ~ .form-checkbox__styled {
  border-color: $blue;
}

input[type='checkbox']:checked + .form-checkbox__checkmark {
  display: block;
}